import {
    getCarousel
} from '../../../core/js/components/carouselComponent';

import template from 'category-primary-content-slot.j2';

import { generate } from '../../../core/js/utils/componentUtils';

export function init(store, overrides = {}) {
    const config = {
        completionCallback: () => getCarousel(),
        templateLocation: '.dom-category__primary-content-slot',
        template: template,
        watch: 'category.primaryContentSlot',
        name: 'primaryContentSlotComponent'
    };

    return generate(config, store, overrides);
}
